import { makeStyles, mergeClasses, Text, useAnnounce } from '@fluentui/react-components';
import { Warning16Regular } from '@fluentui/react-icons';
import { useEffect } from 'react';
import { useCommonIndividualReportTableHeaderStyles } from '../../../hooks/useCommonIndividualReportTableHeaderStyles';
import { customPalette } from '../../../theme';

export interface ICommonIndividualReportHeaderProps {
    actionBar?: React.ReactNode;
    topContentLeft?: React.ReactNode[];
    topContentRight?: React.ReactNode[];
    warningMessage?: string | undefined;
}

const useStyles = makeStyles({
    warningRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
    },
    warningIconWrap: {
        backgroundColor: customPalette.warningBackground,
        borderRadius: '32px',
        display: 'inherit',
        padding: '4px',
    },
    warningText: {
        fontSize: '10px',
        lineHeight: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    buttonBarRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
});

const CommonIndividualReportHeader = (props: ICommonIndividualReportHeaderProps) => {
    const { cardStyles, topSection, buttonBar, buttonBarWrapper } = useCommonIndividualReportTableHeaderStyles();
    const styles = useStyles();
    const { announce } = useAnnounce();
    const { warningMessage } = props;

    useEffect(() => {
        if (warningMessage) {
            announce(warningMessage, { batchId: 'report-header-warning' });
        }
    }, [warningMessage, announce]);

    return (
        <div className={cardStyles}>
            <div className={topSection}>
                {props.topContentLeft}
                {props.topContentRight}
            </div>
            <div className={mergeClasses(buttonBarWrapper, styles.buttonBarRow)}>
                <div className={buttonBar}>{props.actionBar}</div>
                {warningMessage && (
                    <div className={styles.warningRow}>
                        <span className={styles.warningIconWrap}>
                            <Warning16Regular />
                        </span>
                        <Text className={styles.warningText}>{warningMessage}</Text>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CommonIndividualReportHeader;
